import {
  YStack,
  ChatListControlled,
  ChatListControlledProps,
  InputWithRightAddOnControlled,
} from '@my/ui'
import { Paperclip, Send } from '@tamagui/lucide-icons-2'
import { Controller, useForm } from 'react-hook-form'

interface ChatDemoProps {
  messages: ChatListControlledProps['messages']
  pushMessage: (message: string) => void
}

export const ChatDemo: React.FC<ChatDemoProps> = (props) => {
  const methods = useForm({
    defaultValues: {
      chatInput: '',
    },
  })
  const {
    formState: { errors, isDirty },
    control,
    reset,
    getValues,
  } = methods

  const onSubmit = () => {
    const { chatInput } = getValues()
    props.pushMessage(chatInput)
    reset()
  }

  return (
    <YStack marginTop="auto" height="100%" width="100%" f={1}>
      <ChatListControlled messages={props.messages} />

      <Controller
        control={control}
        name="chatInput"
        render={({ field: { onChange, onBlur, value, ref } }) => (
          <InputWithRightAddOnControlled
            onChange={onChange} // send value to hook form
            onBlur={onBlur} // notify when input is touched/blur
            value={value}
            icon={<Send />}
            onButtonPress={onSubmit}
            viewProps={{
              position: 'sticky',
              bottom: 0,
              backgroundColor: '$background',
            }}
          />
        )}
      />
    </YStack>
  )
}
